import WebIM from '../libs/webIM';
import * as types from '../constants/actionTypes';
import { copyMessage as copy } from '../functions/utils';
import { MATCHING_DONTMATCHING, MSG_TEMPLATE as msgTpl } from '../constants/constants';
import * as conversationInboxAction from './conversationInboxAction';
import * as messageTypes from '../constants/messageTypes';
import * as myStore from '../store/myStore';
import { addSendMessage, getCurrentSelectedConversationId, parseFromLocal } from './messageActions';
import {
  CALL_STATE_STARTED_BY,
  SWITCH_CARD_VIDEO_VIEW,
  UPDATE_INTERRUPTID,
  UPDATE_RECEIVING_CALL_TYPE,
  UPDATE_STARTER,
  UPDATE_VIDEO_CALL_STATE,
} from '../constants/actionTypes';
import { notifyMessageSent } from './conversationInboxAction';
import { TYPE_VIDEO_CALL } from '../constants/notificationTypes';
import WebIMConfig from '../libs/webIMConfig';
import configApp from '../../app.json';
import { CALL_STATE_PERMISSION_TYPE } from '../constants/videoRequestType';

const isNative = !configApp || !configApp.isWebApp;

export function callAction(data) {
  return { type: types.CALL_ACTION_SUCCESS, data };
}
export function setLocalStream(data) {
  return { type: types.SET_LOCAL_STREAM_SUCCESS, data };
}

export function setFriendId(friendID) {
  return { type: types.SET_FRIEND_ID, data: { friendID } };
}

export function updateInterrupId(interruptId) {
  return { type: types.UPDATE_INTERRUPTID, data: interruptId };
}

export function updateWindowCallType(windowCallType) {
  return { type: types.UPDATE_WINDOW_CALL_TYPE, data: windowCallType };
}

export function updateReceivingCallType(callType) {
  return { type: types.UPDATE_RECEIVING_CALL_TYPE, data: callType };
}

export function updateMic(disable) {
  return { type: types.UPDATE_MIC, data: !!disable };
}

export function updateMuted(muted) {
  return { type: types.UPDATE_MUTED, data: !!muted };
}

export function updateCameraMode(mode) {
  return { type: types.UPDATE_CAMERA_MODE, data: mode };
}

export function updateVoiceCallLoginUser(isVoiceCall) {
  return { type: types.UPDATE_VOICE_CALL, data: !!isVoiceCall };
}

export function updateVoiceCallPeerUser(isVoiceCall) {
  return { type: types.UPDATE_VOICE_CALL_PEER_USER, data: !!isVoiceCall };
}

export function updateCallState(state) {
  return { type: types.UPDATE_STATE_CALL, data: state };
}

export function updateStarter(isStarter) {
  return { type: types.UPDATE_STARTER, data: !!isStarter };
}

export function setPeerStream(data) {
  return { type: types.SET_PEER_STREAM_SUCCESS, data };
}

export function showLocalPhoto(data) {
  return { type: types.SHOW_LOCAL_PHOTO_SUCCESS, data };
}

export function showPeerPhoto(data) {
  return { type: types.SHOW_PEER_PHOTO_SUCCESS, data };
}

export function setPeerPhotoUrl(data) {
  return { type: types.SET_PEER_PHOTO_SUCCESS, data };
}

export function changeStatusIncomingCall(data) {
  return { type: types.CHANGE_STATUS_INCOMINGCALL, data };
}

export function hideStatusBar(data) {
  return { type: types.HIDE_STATUS_BAR, data };
}

export function endCall() {
  return { type: types.END_CALL_SUCCESS };

  // return (dispatch, getState) => {
  //   //dispatch(showStatusBar());
  //   };
}

export function addPeerUserCallInfo(data) {
  return { type: types.ADD_PEER_USER_CALL_INFO_SUCCESS, data };

  // return (dispatch, getState) => {
  //   //dispatch(showStatusBar());
  //   };
}

export function updateVideoCallState(state) {
  return { type: types.UPDATE_VIDEO_CALL_STATE, data: state };
}

export function changeStatusVideoCallWindow(data) {
  return { type: types.CHANGE_STATUS_VIDEO_CALL_WINDOW, data };
}

export function acceptCall(callInfo) {
  return { type: types.ACCEPT_CALL_SUCCESS, data: callInfo };
}

export function updateListVideoDevices(data) {
  return { type: types.UPDATE_LIST_VIDEO_DEVICES, data };
}

export function countDownOrResetTimeCall(timeCountReceive) {
  return { type: types.COUNT_DOWN_OR_RESET_TIME_CALL, data: timeCountReceive };
}
function getLoginXmppId() {
  const login = myStore.getStore().getState().loginReducer;
  if (login && login.userInfo) {
    return login.userInfo.xmppId;
  }
  return '';
}

export function setRequestTypeCall() {
  return { type: types.SET_REQUEST_TYPE_CALL };
}

export function sendVideoMessage(requestType, chatId, message, senderMemberLevel = 1, recvMemberLevel = 1, isRecvMatching = false, isSenderMatching = false) {
  const numberRecvMatching = isRecvMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  const numberSenderMatching = isSenderMatching ? MATCHING_DONTMATCHING.MATCHING : MATCHING_DONTMATCHING.DONT_MATCHING;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      try {
        const _message = { data: message };
        const pMessage = parseFromLocal('chat', chatId, _message, messageTypes.TYPE_VIDEO, true);
        pMessage.time = +new Date();
        pMessage.bySelf = true;
        pMessage.body.recvMemberLevel = recvMemberLevel;
        pMessage.body.senderMemberLevel = senderMemberLevel;
        pMessage.body.isRecvMatching = numberRecvMatching;
        pMessage.body.isSenderMatching = numberSenderMatching;
        pMessage.convId = getCurrentSelectedConversationId();
        const { body, id, to } = pMessage;
        const { type, data } = body;
        let msg;

        switch (requestType) {
          case 'end':
            msg = new WebIM.message(type, id);

            if (message === null) {
              msg.set({
                data,
                to,
                requestType,
                time: pMessage.time,
              });
            } else {
              msg.set({
                data,
                senderMemberLevel,
                recvMemberLevel,
                isRecvMatching: numberRecvMatching,
                isSenderMatching: numberSenderMatching,
                to,
                requestType,
                time: pMessage.time,
              });
            }
            WebIM.conn.send(msg.body);
            // delete the message video call request replace by the message video call end
            // dispatch(messageAction.sendDelete(message.id, chatId));
            // add the temp video call message into device
            if (message !== null) {
              dispatch(addSendMessage(pMessage, type));
              // update unreadCount and last _message for conversation
              dispatch(conversationInboxAction.updateUnreadAndLastMessage(pMessage));
              if (!WebIMConfig.isEnableStreamManagementFeature && !isNative) {
                dispatch(
                  notifyMessageSent(to, message, TYPE_VIDEO_CALL, '', {
                    messageObject: pMessage,
                  })
                );
              }
            }
            break;
          case 'request-voice':
          case 'request':
          case 'answer':
          case 'watch':
          case 'call':
          case 'busy': {
            const msgId = WebIM.conn.getUniqueId();
            msg = new WebIM.message(type, msgId);
            msg.set({
              to,
              requestType,
              data: data || '',
              time: pMessage.time,
            });
            WebIM.conn.send(msg.body);
            break;
          }
          default:
            break;
        }

        resolve(pMessage);
      } catch (e) {
        console.log('Error send video call message', e);
        // eslint-disable-next-line prefer-promise-reject-errors
        resolve(null);
      }
    });
  };
}

export function minimizeCall(data) {
  return { type: types.VIDEO_CALL_MINIMIZE, data };
}

export function getRequestInfo(message) {
  return { type: types.GET_REQUEST_SUCCESS, message };
}

export function toggleFullScreen(status) {
  return { type: types.VIDEO_CALL_FULLSCREEN, status: !!status };
}

export function toggleCardVideoView(status) {
  return { type: types.SWITCH_CARD_VIDEO_VIEW, data: !!status };
}

export function cleanUpVideoCall() {
  return { type: types.CLEAN_UP_VIDEO_CALL };
}

export function updateCallStateStartedBy(permission = CALL_STATE_PERMISSION_TYPE.VIDEO) {
  return { type: types.CALL_STATE_STARTED_BY, data: permission };
}
